
export class CarritoXls {
    idLinea: string;
    descLinea: string;	
    idSubLinea: string;	
    descSubLinea: string;
    idProducto: string;
    codigodebarras: string;
    descProducto: string;
    cantidad_Solicitada: number;
    preciounitario: number;
    valortotal: number; 
  }